module.exports = __webpack_public_path__ + "r-v3/img/pen_on.396e270e.svg";